<!--
 * @Author: gongzhichao
 * @Date: 2023-05-10 11:37:00
 * @LastEditors: gongzhichao 18311120024@163.com
 * @Description: 二级页面公共组件
-->
<template>
  <div class='main'>
    <div class='show-area'></div>
    <div class='information'>
      <DownloadUtil></DownloadUtil>
      <div class='content'>
        <Breadcrumb></Breadcrumb>
        <div class='content-slot'>
          <slot></slot>
        </div>
      </div>
    </div>
    <div class='footer-outside'>
      <div class='game-info'>
        <div class='info'>
          <div class='code-area'>
            <div class='code'>
              <img src='../../../../assets/image/pc/wechat-code.jpg' alt />
            </div>
            <span>微信公众号</span>
          </div>
          <div class='text-area'>
            <span>《群侠传》手游</span>
            <span>Q版人物，精致可爱！修炼经脉，真气纳海！门派激战，欢乐无限！</span>
            <div
              class='detail'
            >《群侠传》手游是一款高自由度Q版千年手游，游戏融入经脉设定，支持自由交易，自创武功。尽全力为大家还原每个人心中的武侠梦。仗剑纵马，纵横江湖，行侠仗义，快意恩仇！</div>
          </div>
        </div>
      </div>
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "../Breadcrumb/Breadcrumb.vue";
import Footer from "../../../../components/pc/Footer";
import DownloadUtil from "../DownloadUtil/DownloadUtil.vue";
export default {
  metaInfo: {
    meta: [
      {
        name: "description",
        content:
          "《群侠传》是一款Q版千年武侠风格的即时战斗MMORPG游戏，自由探索、交易、战斗、结交各路英雄，能让你感觉到进入了一个充满江湖气息的世界！",
      },
      {
        name: "keywords",
        content:
          "群侠传,群侠传手游,群侠传官网,群侠传手游官网,千年三,千年手游,千年官网,千年手游官网,武林群侠传,九妖,九妖官网,九妖手游,九妖手游官网,千年三官网,千年盛世,千年盛世手游,千年盛世官网,千年游戏盒子,Q版武侠,开放世界手游,巴雄天下,剑雨如歌,侠众道,异侠传,异侠传手游,金庸群侠传,剑网三手游,仙剑世界,千年游戏,千年盒子",
      },
    ],
  },
  components: { Footer, Breadcrumb, DownloadUtil },
};
</script>

<style lang="scss" scoped>
.main {
  min-width: 1920px;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;

  .show-area {
    width: 100%;
    height: 330px;
    // background-color: #fff;
    margin-top: 90px;
    background: url('~@/assets/image/pc/basemap-second-header.png') no-repeat;
    background-size: 100% 100%;
  }
  .information {
    display: flex;
    width: 100%;
    height: auto;
    background: url('~@/assets/image/pc/basemap-second-content.png') no-repeat;
    background-size: 100% 100%;
    z-index: 999;
    .content {
      width: 1385px;
      height: auto;

      .content-slot {
        width: 100%;
        height: 100%;
        overflow-y: auto;
        overflow-x: hidden;
      }
    }
  }

  .footer-outside {
    width: 1920px;
    height: 812px;
    background: url('~@/assets/image/pc/basemap-second-footer.png') no-repeat;
    background-size: 100% 100%;
    .game-info {
      position: relative;
      width: 100%;
      height: 493px;
      background: url('~@/assets/image/pc/basemap-gameInfo.png') no-repeat;
      background-size: 100% 100%;
      .info {
        position: absolute;
        display: flex;
        justify-content: space-between;
        align-items: center;
        top: 207px;
        right: 65px;
        width: 1335px;
        height: 255px;
        .code-area {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          width: 156px;
          height: 255px;
          .code {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 136px;
            height: 136px;
            border-radius: 20px;
            background-color: #fff;
            box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1),
              0px 10px 15px -3px rgba(0, 0, 0, 0.1);
            img {
              width: 91%;
              height: 91%;
            }
          }
          span {
            font-size: 28px;
            font-weight: 600;
            color: #866e4f;
            margin-top: 10px;
          }
        }
        .text-area {
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          width: 1110px;
          height: 220px;
          font-weight: 600;

          span:nth-child(1) {
            font-size: 34px;
            color: #866e4f;
          }
          span:nth-child(2) {
            font-size: 18px;
            font-weight: 600;
            color: #866e4f;
            margin-left: 15px;
          }
          .detail {
            width: 940px;
            font-size: 22px;
            color: #866e4f;
            line-height: 2;
            margin-left: 4px;
          }
        }
      }
    }
  }
}
</style>
